<div class="lender-credits-fees-container">
  <form #lenderCreditsFeesForm="ngForm" class="lender-credits-fees-form">
    <div class="section-header mb-3">
      <h5>Lender Credits</h5>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Lender Credit</label>
        <currency-input
          [(ngModel)]="formData.interestRateCredit"
          name="interestRateCredit"
          [allowEmpty]="true">
        </currency-input>
      </div>
    </div>

    <div class="section-header mb-3 mt-4">
      <h5>Other Fees (Section H)</h5>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Wire Fee</label>
        <currency-input
          [(ngModel)]="formData.wireFee"
          name="wireFee"
          [allowEmpty]="true">
        </currency-input>
      </div>
    </div>

    <!-- Dynamic Fees Section -->
    <div class="dynamic-fees-section mt-4">
      <div class="section-header mb-3">
        <h6>Additional Other Fees</h6>
      </div>
      @if (formData.dynamicFees.length > 0) {
        <div class="row mb-2">
          <div class="col-md-6"><strong>Fee Name</strong></div>
          <div class="col-md-5"><strong>Amount ($)</strong></div>
          <div class="col-md-1"></div>
        </div>
      }

      @for (fee of formData.dynamicFees; track fee.uuid; let i = $index) {
        <div class="row mb-2">
          <div class="col-md-6">
            <input type="text" class="form-control" [(ngModel)]="fee.name"
                   [name]="'dynamicFeeName_' + i" placeholder="Fee name">
          </div>
          <div class="col-md-5">
            <currency-input [(ngModel)]="fee.amount" [name]="'dynamicFeeAmount_' + i"
                            [allowEmpty]="true">
            </currency-input>
          </div>
          <div class="col-md-1">
            <button type="button" class="btn btn-sm btn-danger"
                    (click)="removeDynamicFee(i)">
              <i class="pi pi-trash"></i>
            </button>
          </div>
        </div>
      }

      <button type="button" class="btn btn-sm btn-primary mt-2"
              (click)="addDynamicFee()">
        <i class="pi pi-plus"></i> Add Fee
      </button>
    </div>
  </form>
</div>
